export const APP_DOMAIN = process.env.VUE_APP_DOMAIN;
export const API_URL = process.env.VUE_APP_API_URL || "localhost";
export const REDIRECT_URI = process.env.VUE_APP_REDIRECT_URI;
export const NEXT360_APPID = process.env.VUE_APP_NEXT360_APPID;
export const NEXTSHOP_APPID = process.env.VUE_APP_NEXTSHOP_APPID;
export const NEXT360_URL_HOST = process.env.VUE_APP_NEXT360_URL_HOST;
export const DOMAIN_TITLE = process.env.DOMAIN_TITLE || "Đăng nhập";
export const MPOS_ROOT_URI = process.env.VUE_APP_MPOS_ROOT_URI || "";
export const MPOS_CALLBACK_URI = process.env.VUE_APP_MPOS_CALLBACK_URI || "";
